/**
 * 设备标识相关工具函数
 */

/**
 * 从 userAgent 提取设备类型和版本信息
 * 返回格式示例：iPhone/iOS18.3、Android/15、iPad/iPadOS17、PC/Windows、PC/macOS
 * @returns 设备描述字符串
 */
export function getDevice(): string {
  const ua = navigator.userAgent

  // iPhone
  const iphoneMatch = ua.match(/iPhone.*?OS ([\d_]+)/)
  if (iphoneMatch?.[1]) {
    return `iPhone/iOS${iphoneMatch[1].replace(/_/g, '.')}`
  }

  // iPad
  const ipadMatch = ua.match(/iPad.*?OS ([\d_]+)/)
  if (ipadMatch?.[1]) {
    return `iPad/iPadOS${ipadMatch[1].replace(/_/g, '.')}`
  }

  // Android
  const androidMatch = ua.match(/Android ([\d.]+)/)
  if (androidMatch?.[1]) {
    return `Android/${androidMatch[1]}`
  }

  // Windows
  const windowsMatch = ua.match(/Windows NT ([\d.]+)/)
  if (windowsMatch?.[1]) {
    return `PC/Windows${windowsMatch[1]}`
  }

  // macOS
  const macMatch = ua.match(/Mac OS X ([\d_]+)/)
  if (macMatch?.[1]) {
    return `PC/macOS${macMatch[1].replace(/_/g, '.')}`
  }

  return 'PC/Unknown'
}
